export default {"src":"/_next/static/media/lune-icon-live-chart.cf4fda2b.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};